import { Route } from '@angular/router';
import { Secure } from './secure';
import { authGuard } from '../../core/guards/auth.guard';

export const secureRoutes: Route[] = [
  {
    path: 'secure',
    component: Secure,
    canActivate: [authGuard],
    children: [
      {
        path: 'management',
        loadComponent: () => import('./management/management').then(m => m.Management),
      },
      {
        path: '',
        redirectTo: 'management',
        pathMatch: 'full',
      },
    ],
  }
  // {
  //   path: '**',
  //   redirectTo: 'secure/dashboard',
  // },
];
